export function workedTime(hours, preciseTime) {
  const match = String(preciseTime || '').match(/^(\d+):(\d{2}):(\d{2})$/);
  const minutes = match
    ? Number(match[1]) * 60 + Number(match[2])
    : Math.floor(Math.max(0, Number(hours) || 0) * 60 + 0.000001);
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, '0')}m`;
}
